export const SHOW_TOOLTIP = 'tooltip/SHOW_TOOLTIP';
export const HIDE_TOOLTIP = 'tooltip/HIDE_TOOLTIP';

export function requestShowToolTip(data) {
  return {
    type: SHOW_TOOLTIP,
    data,
  };
}

export function requestHideToolTip() {
  return {
    type: HIDE_TOOLTIP,
  };
}
